export const ROUTES = {
  BUSINESS_ACCOUNT: '/business-account',
  CHARITY_DASHBOARD: '/dashboard-charity',
}
